// extracted by mini-css-extract-plugin
module.exports = {"image-group":"image-group--2HAJq","header":"header--2QrDB","title":"title--20j62","children":"children--2S_98","-central":"-central--wCOb6"};